import './GraftabilityRow.module.scss'

export const GRAFTABILITY_WARNING_ICON_CLASS = 'icon--warning'
